import { withTranslation } from 'react-i18next';
import React, { Fragment, Component } from 'react';

class DynamicTextRace extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};

	}

    render() {
        let experience = '';
        switch(parseInt(this.props.experience, 10)) {
            case 6:
                experience = this.props.t('DynamicText_Beginner');
                break;
            case 7:
                experience = this.props.t('DynamicText_LittleExperience');
                break;
            case 8:
                experience = this.props.t('DynamicText_Experienced');
                break;
            case 9:
                experience = this.props.t('DynamicText_VeryExperienced');
                break;
            case 10:
                experience = this.props.t('DynamicText_Expert');
                break;
            default:
                experience = '';
        }

        let bikeType = '';
        switch(this.props.bikeType) {
            case 'Aero':
                bikeType = this.props.t('aerodynamische racefiets');
                break;
            case 'Hill':
                bikeType = this.props.t('lichte racefiets');
                break;
            case 'Race':
                bikeType = this.props.t('racefiets');
                break;
            case 'Endurance':
                bikeType = this.props.t('comfortabele racefiets');
                break;
            case 'Timetrial':
                bikeType = this.props.t('tijdritfiets');
                break;
            case 'Cyclocross':
                bikeType = this.props.t('veldrijfiets');
                break;
            case 'Gravel':
                bikeType = this.props.t('gravelfiets');
                break;
            default:
                this.props.bikeType.toLowerCase();
        }

        let speed = this.props.speed;
        switch(parseInt(this.props.speed, 10)) {
            case 4:
                speed = this.props.t('DynamicText_Speed');
                break;
            case 5:
                speed = this.props.t('DynamicText_Speed_Comfort');
                break;
            case 6:
                speed = this.props.t('DynamicText_Comfort');
                break;
            default:
                speed = '';
        }

        let image = '';
        switch (parseInt(this.props.image, 10)) {
            case 1:
                image = <Fragment>{this.props.t('DynamicText_YouAreSearching')} <strong>{this.props.t('DynamicText_TopBike')}</strong></Fragment>;
                break;
            case 2:
                image = <Fragment>{this.props.t('DynamicText_YouHavePreference')} <strong>{this.props.t('DynamicText_SpecificBrands')}</strong></Fragment>;
                break;
            default:
                image = <Fragment>{this.props.t('DynamicText_YouAreSearching')}<strong>{this.props.t('DynamicText_PriceQuality')}</strong></Fragment>;
        }

        return (
            <div className="text-center well">
                <h3>{this.props.title}</h3>
                <p>{this.props.t('DynamicText_YouHaveSaid')} <strong>{experience}</strong> {this.props.t('DynamicText_ToBeARacer')}. {this.props.t('DynamicText_YouAreSearching')} <strong>{bikeType}</strong>. {this.props.t('DynamicText_ForYouItIs')} <strong>{speed}</strong> {this.props.t('DynamicText_ImportantAnd')} {image}. {this.props.t('DynamicText_WeAdviceYou')} {this.props.t('DynamicText_Maximum')} <strong>{this.props.advicePrice}</strong> {this.props.t('DynamicText_Euro')} {this.props.t('DynamicText_EndText')}</p>
            </div>
        );

    }

}

export default withTranslation('price')(DynamicTextRace);
